'use client';

import useSetDataDogContext from '~/hooks/flp/telemetry/useSetDataDogContext';

export default function FinancingData() {
  useSetDataDogContext();

  return null;
}
